import {Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';

@Pipe({
    name: 'authenticatioType',
})

/**
 * authentication pipe returns the specific type
 */
export class AuthenticatioTypePipe implements PipeTransform {
    constructor(private _translocoService:TranslocoService){}
    transform(type: string, isReturnLabeL: boolean = false): {svg:string, type:string} {
        const types = {
            "e_signature": this._translocoService.translate("Authentication E-signature tooltip text (Template/Document RecipientTab - section) - E-signature"),
            "bank_id": "BankID",
            "e_sign_and_sms_pin": this._translocoService.translate("Authentication E-sign and sms pin tooltip text (Template/Document RecipientTab - section) - E-sign and SMS PIN"),
            "read_only": this._translocoService.translate("Authentication read only tooltip text (Template/Document RecipientTab - section) - Read only"),
            "attest": this._translocoService.translate("Authentication attest tooltip text (Template/Document RecipientTab - section) - Attest"),
            "norwegian_bank_id": "Norwegian BankID",
            "finnish_bank_id": "Finnish BankID",
            "danish_mit_id": "Danish MitID"
        }
        if(isReturnLabeL) { return types[type] }  
        const iconType = ['danish_bank_id', 'finnish_bank_id'].includes(String(type)) ? 'png' : 'svg';
        return { svg: `assets/images/authentication-icons/${type}.${iconType}`, type: `${types[type]}` };
    }
}
